import { Building, ShieldCheck, TrendingUp, Users } from "lucide-react";

const AuthRightSide = () => {
  return (
    <div className="max-md:hidden h-full w-1/2 bg-gradient-to-br from-primary to-secondary flex items-center justify-center p-8 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute bg-white/30 top-10 left-10 w-32 h-32 border border-white/20 rounded-full" />
        <div className="absolute bg-white/30 top-32 right-20 w-24 h-24 border border-white/20 rounded-full" />
        <div className="absolute bg-white/30 bottom-20 left-20 w-40 h-40 border border-white/20 rounded-full" />
        <div className="absolute bg-white/30 bottom-32 right-10 w-28 h-28 border border-white/20 rounded-full" />
      </div>

      <div className="relative z-10 text-center text-white space-y-8 max-w-md">
        <div className="mx-auto w-24 h-24 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm">
          <Building className="w-12 h-12 text-white" />
        </div>

        <div className="space-y-3">
          <h2 className="text-2xl font-bold">Welcome to Prudential</h2>
          <p className="text-white/90 text-xl font-semibold  leading-relaxed">
            Agent Onboarding
          </p>
        </div>

        <div className="space-4 flex items-center gap-8">
          <div className=" space-x-3 text-center flex items-center flex-col gap-2">
            <div className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm">
              <ShieldCheck className="w-5 h-5 text-white" />
            </div>
            <div>
              <div className="font-medium text-sm">Trusted Platform</div>
              <div className="text-white/70 text-xs">Secure and reliable</div>
            </div>
          </div>

          <div className=" space-x-3 text-center flex items-center flex-col gap-2">
            <div className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm">
              <TrendingUp className="w-5 h-5 text-white" />
            </div>
            <div>
              <div className="font-medium text-sm">Career Growth</div>
              <div className="text-white/70 text-xs">Unlimited potential</div>
            </div>
          </div>

          <div className=" space-x-3 text-center flex items-center flex-col gap-2">
            <div className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm">
              <Users className="w-5 h-5 text-white" />
            </div>
            <div>
              <div className="font-medium text-sm">Expert Support</div>
              <div className="text-white/70 text-xs">24/7 assistance</div>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 gap-4 pt-6 border-t border-white/20">
          <div className="text-center">
            <div className="text-xl font-bold">50K+</div>
            <div className="text-xs text-white/70">Active Agents</div>
          </div>
          <div className="text-center">
            <div className="text-xl font-bold">177+</div>
            <div className="text-xs text-white/70">Years Strong</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthRightSide;
